import React from 'react';

const Gif = props => (
	<div style={{ maxWidth: '1000px', margin: '0 auto' }}>
		<picture className="picture">
			<source
				srcSet={'./img/' + props.contenido + '.png'}
				media="(min-width: 500px)"
			/>
			<img
				style={{ paddingTop: '1em', width: '100%', height: 'auto' }}
				className="foto"
				src={'./img/' + props.contenido + '.gif'}
				alt=""
			/>
		</picture>
	</div>
);

export default Gif;



// WEBPACK FOOTER //
// ./src/components/Gif.js